import { render, staticRenderFns } from "./OrderRowAction.vue?vue&type=template&id=b476003a"
import script from "./OrderRowAction.vue?vue&type=script&lang=js"
export * from "./OrderRowAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports